import { useEffect, useRef, useState } from "react";

import UnivoImage from "@/components/common/UnivoImage";
import style from "./ProgramCard2.module.scss";

const LazyloadComponentOnView = ({ source, alt }) => {
  const [inView, setInView] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        observer.disconnect();
      }
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    setLoaded(false);
  }, [source]);

  const showSkeleton = !inView || !loaded;

  return (
    <div
      ref={sectionRef}
      className={style.prgm_card_box}
    >
      {showSkeleton && (
        <div
          className={style.imageSkeleton}
          aria-hidden
        />
      )}
      {inView && source ? (
        <UnivoImage
          src={source}
          alt={alt}
          fill
          loading="lazy"
          fetchPriority="low"
          sizes="(max-width: 1024px) 296px, 250px"
          className={loaded ? style.imageVisible : style.imageHidden}
          style={{ objectFit: "cover", objectPosition: "center" }}
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)}
        />
      ) : null}
    </div>
  );
};

export default LazyloadComponentOnView;
